var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "currentColor",
    className: "bi bi-info-circle",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1359",
    "data-name": "Gruppe 1359",
    transform: "translate(-97.999 -1011.367)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1356",
    "data-name": "Gruppe 1356",
    transform: "translate(97.999 1011.367)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4256",
    "data-name": "Pfad 4256",
    d: "M109,1033.367a11,11,0,1,1,11-11A11.012,11.012,0,0,1,109,1033.367Zm0-20.411a9.412,9.412,0,1,0,9.412,9.412A9.422,9.422,0,0,0,109,1012.955Z",
    transform: "translate(-97.999 -1011.367)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1358",
    "data-name": "Gruppe 1358",
    transform: "translate(108.035 1016.978)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1357",
    "data-name": "Gruppe 1357"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4257",
    "data-name": "Pfad 4257",
    d: "M116.954,1021.965h1.913v1.715h-1.913Zm0,3.036h1.928v7.741h-1.928Z",
    transform: "translate(-116.954 -1021.965)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info-circle.00541044.svg";
export { ForwardRef as ReactComponent };